// Base
import { useEffect } from "react";

// Sections
import Checkout from "@/sections/Checkout";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";

// Store
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore";

// Utils
import getCookie from "@/func/getCookie";

export default function Layout() {
  const { isMobile } = useTemplateStore();
  const productData = useProductData();

  useEffect(() => {
    const encodedAffParam = new URL(location.href).searchParams.get("aff");
    let affiliateTag: string | undefined;

    if (encodedAffParam) {
      try {
        affiliateTag = atob(encodedAffParam);
      } catch {
        console.warn("Failed to decode aff param");
        affiliateTag = undefined;
      }
    }

    const affCookie = getCookie("affiliate_tag");
    if (!affiliateTag) affiliateTag = affCookie ?? undefined;

    if (window.postId !== undefined) {
      productData.get({
        postId: window.postId,
        isMobile: isMobile,
        affParam: affiliateTag,
      });
    }
  }, [isMobile]);

  return (
    <>
      <Header />
      <Checkout />
      <Footer />
    </>
  );
}
